import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type WeddingLightBulbIconProps = CreateIconComponentProps;
export const WeddingLightBulbIcon: React.FC<WeddingLightBulbIconProps> = ({
  title = 'WeddingLightBulb',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="1.7"
      d="M12.832 17.27V15.2s.018-1.385.995-2.463c1.206-1.333 2.131-2.289 2.206-3.384.087-1.272-.899-2.363-2.122-2.39-.925-.017-1.5.61-1.758.895-.544.6-1.079 1.907-1.043 2.683.035.771.81.789.916.789.105 0 .88-.018.916-.79.035-.771-.5-2.082-1.043-2.682-.26-.285-.833-.912-1.758-.895-1.224.022-2.214 1.118-2.122 2.39.074 1.095 1 2.051 2.205 3.384.977 1.078.995 2.464.995 2.464v2.069"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="1.7"
      d="M19.435 8.918c0-4.13-3.38-7.474-7.523-7.417-3.946.057-7.185 3.235-7.308 7.176a7.41 7.41 0 0 0 2.608 5.892A7.635 7.635 0 0 1 9.9 20.382a2.116 2.116 0 1 0 4.235 0c0-2.248 1.004-4.37 2.713-5.835a7.4 7.4 0 0 0 2.587-5.629ZM14.748 17.397H9.29M14.266 19.795H9.794"
    />
  </CreateIconComponent>
);
